(function () {
  'use strict';

  function setMainImage(main, thumbs, src) {
    main.src = src;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    // sync active thumb to the one whose full-src matches
    thumbs.forEach(function (tt) {
      tt.removeAttribute('data-active');
      if (tt.getAttribute('data-full-src') === src) tt.setAttribute('data-active', 'true');
    });
  }

  function init() {
    document.querySelectorAll('.mel-gallery').forEach(function (root) {
      var main = root.querySelector('.mel-gallery__main img');
      if (!main) return;
      var thumbs = root.querySelectorAll('.mel-gallery__thumb');

      // Thumbnail clicks
      thumbs.forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          var fullSrc = t.getAttribute('data-full-src');
          if (!fullSrc) return;
          setMainImage(main, thumbs, fullSrc);
        });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
        });
      });
      if (thumbs[0]) thumbs[0].setAttribute('data-active', 'true');

      // Color swatch changes → swap main image
      var form = root.closest('section') ? root.closest('section').querySelector('.mel-product-form') : null;
      if (form) {
        form.addEventListener('change', function (e) {
          var input = e.target;
          if (input.type !== 'radio') return;
          var label = input.closest('[data-variant-img]');
          if (!label) return;
          var src = label.getAttribute('data-variant-img');
          if (src) setMainImage(main, thumbs, src);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
